import LeadsTable from "./LeadsTable";
export { LeadsTable };
